import { render, staticRenderFns } from "./PayrollTable.vue?vue&type=template&id=193852f2&scoped=true&"
import script from "./PayrollTable.vue?vue&type=script&setup=true&lang=js&"
export * from "./PayrollTable.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193852f2",
  null
  
)

export default component.exports